<template>
  <div class="Login">
    <!-- <mu-appbar style="width: 100%;" title="郑煤机集团科技文化展示中心" color="primary">
      <div slot="left" class="leftlogo">
        <img height="46" src="../../../static/img/logo.png">
      </div>
    </mu-appbar> -->

    <div v-show="getIsShow">
      <mu-container class="LoginContainer">
        <mu-form ref="form" :model="LoginForm" class="mu-demo-form">
          <mu-form-item :rules="usernameRules" label="用户名" prop="username">
            <mu-text-field v-model="LoginForm.username" prop="username"/>
          </mu-form-item>
          <mu-form-item :rules="passwordRules" label="密码" prop="password">
            <mu-text-field v-model="LoginForm.password" type="password" prop="password"/>
          </mu-form-item>
        </mu-form>
      </mu-container>

      <mu-container class="LoginBtn">
        <mu-button color="primary" @click="submit">登陆</mu-button>
        <mu-button @click="clear">重置</mu-button>
      </mu-container>

      <mu-container class="WxBtn">
        <mu-button fab color="#01B307" @click="WxLogin">
          <img height="20" src="../../../static/img/wechart.png">
        </mu-button>
        <div class="WxText">使用微信登陆</div>
      </mu-container>
    </div>

    <div v-show="token" class="Logined">
      <!-- <mu-container class="LoginedContainer">
        <mu-row justify-content="center">
          <mu-avatar size="150">
            <img src="../../../static/img/avatar.jpg">
          </mu-avatar>
        </mu-row>
        <mu-row justify-content="center" class="LogoutBtn">
          <mu-button color="primary" @click="Logout">退出</mu-button>
        </mu-row>
      </mu-container> -->
      <user-card @Logout="Logout" @Refresh="Refresh"/>
      <mu-divider/>
      <mu-tabs :value.sync="active" full-width>
        <mu-tab>
          <mu-badge :content="getWaitVerifyNum" circle color="secondary" class="demo-icon-badge">
            实体展厅
          </mu-badge>
        </mu-tab>
        <mu-tab>
          <mu-badge :content="getWaitOnlineNum" circle color="secondary" class="demo-icon-badge">
            网上展厅-未审核
          </mu-badge>
        </mu-tab>
        <mu-tab>
          <mu-badge :content="getVeredNum" circle color="secondary" class="demo-icon-badge">
            网上展厅-已通过
          </mu-badge>
        </mu-tab>
      </mu-tabs>
      <div v-show="active === 0">
        <verify ref="Verify" @WaitVerifyNum="SetWaitNum"/>
      </div>
      <div v-show="active === 1" class="OnlineVer">
        <online-verify ref="OnlineVerify" @SetWaitOnlineNum="SetWaitNum" @WaitVerSucc="WaitVerSucc"/>
      </div>
      <div v-show="active === 2">
        <online-verifed ref="OnlineVered" @SetWaitVeredNum="SetWaitNum"/>
      </div>
    </div>

    <div v-show="wxtoken">
      <wx-user-card/>
    </div>
  </div>
</template>

<script>
import { UserCard, Verify, WxUserCard, OnlineVerify, OnlineVerifed } from './components/index'
// import { UserLogin, UserLogout, GetWxUserInfo } from '@/api/all'
import { UserLogin, UserLogout } from '@/api/all'
import { mapGetters } from 'vuex'
import Toast from 'muse-ui-toast'
import { getQueryString } from '../../utils/common'
export default {
  name: 'Login',
  components: { UserCard, Verify, WxUserCard, OnlineVerify, OnlineVerifed },
  data() {
    return {
      usernameRules: [
        { validate: (val) => !!val, message: '必须填写用户名' },
        { validate: (val) => val.length >= 3, message: '用户名长度大于3' }
      ],
      passwordRules: [
        { validate: (val) => !!val, message: '必须填写密码' },
        { validate: (val) => val.length >= 3 && val.length <= 20, message: '密码长度大于3小于10' }
      ],
      LoginForm: {
        username: '',
        password: ''
      },
      active: 0,
      WaitVerifyNum: 0,
      WaitOnlineNum: 0,
      VeredNum: 0
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'wxtoken'
    ]),
    getIsShow: function() {
      if (this.$store.getters.wxtoken) {
        return false
      }
      if (this.$store.getters.token) {
        return false
      }
      return true
    },
    getWaitVerifyNum: function() {
      return this.WaitVerifyNum.toString()
    },
    getWaitOnlineNum: function() {
      return this.WaitOnlineNum.toString()
    },
    getVeredNum: function() {
      return this.VeredNum.toString()
    }
  },
  mounted() {
    // var code = getQueryString('code')
    // console.log(code)
    // if (code) {
    //   const loading = this.$loading()
    //   GetWxUserInfo(code).then(res => {
    //     console.log(res)
    //     if (res.error !== 0) {
    //       Toast.error(res.msg)
    //     } else {
    //       Toast.success(res.msg)
    //       this.$store.dispatch('setWxToken', res.data.UserToken)
    //       this.$store.dispatch('setWxUserInfo', res.data)
    //     }
    //     loading.close()
    //   })
    // }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('setActiveBar', 'login')
    })
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          UserLogin(this.LoginForm.username, this.LoginForm.password).then(res => {
            console.log(res)
            if (res.error === 0) {
              this.$store.dispatch('setToken', res.data.Token)
              this.$refs.Verify.GetWaitVerifyList()
              this.$refs.OnlineVerify.GetAppList(1, 15)
              this.$refs.OnlineVered.GetAppList(1, 15)
            } else {
              Toast.error(res.msg)
            }
          })
        }
      })
    },
    clear() {
      this.$refs.form.clear()
      this.LoginForm = {
        username: '',
        password: ''
      }
    },
    Logout: function() {
      UserLogout().then(res => {
        if (res.error === 0) {
          this.$store.dispatch('removeToken')
        } else {
          Toast.error(res.msg)
          this.$store.dispatch('removeToken')
        }
      })
    },
    Refresh: function() {
      this.$refs.Verify.GetWaitVerifyList()
      this.$refs.OnlineVerify.GetAppList(1, 15)
      this.$refs.OnlineVered.GetAppList(1, 15)
    },
    WxLogin: function() {
      var AppId = 'wx62efb5485152c882'
      // var AppId = 'wxb497fec48eea1e29'
      var RedUrl = encodeURI(window.location.href).split('#')[0]
      // https://ztyy.zmj.com/
      var Code = getQueryString('code')
      if (Code) {
        RedUrl = RedUrl.split('?')[0]
      }
      // var RedUrl = encodeURI('https://ztyy.zmj.com/')
      var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + AppId + '&redirect_uri=' + RedUrl + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href = url
    },
    SetWaitNum: function(type, Num) {
      if (type === 1) {
        this.WaitVerifyNum = Num
      }
      if (type === 2) {
        this.WaitOnlineNum = Num
      }
      if (type === 3) {
        this.VeredNum = Num
      }
    },
    WaitVerSucc: function() {
      this.$refs.OnlineVered.GetAppList(1, 15)
    }
  }
}
</script>

<style scoped>
.Login{
  height: 100%;
}
.leftlogo{
  line-height: 1;
  margin-left: 5px;
}
.LoginContainer{
  padding: 50px 10px 20px 10px;
}
.LoginBtn{
  text-align: center;
  width: 100%;
}
.Logined{
  height: 100%;
}
.LogoutBtn{
  margin-top: 50px;
}
.WxBtn{
  text-align: center;
  margin-top: 50px;
}
.WxText{
  margin-top: 10px;
}
.OnlineVer{
  max-height: calc(100% - 234px);
}
</style>



// WEBPACK FOOTER //
// src/view/Login/index.vue